import { OS_INFO, getBrowserName } from '@ringcentral/rwc-utils/src/client-detection';

// Separate from track-event.js so light pages can tag analytics events
// without pulling the in-meeting track-event graph into their bundles.
export const withEndPoint = <T extends object>(props: T) => ({
    ...props,
    endPoint: `${OS_INFO}: ${getBrowserName()}`,
});
